<template>
  <div class="vm-category-select">
    <div
      class="category-item flex-justify-content-space-between"
      v-if="browser_size == 'small'"
      @click="open"
    >
      <div class="flex-box flex-align-items-center">
        <div class="wh32 mr16">
          <pic :src="`${this.GL.PIC_HOST}/static/img/category/all@2x.png`"></pic>
        </div>
        {{category_name}}
      </div>
      <i class="afd afd-arrow-down"></i>
    </div>
    <div class="category-list" :class="{active: is_active}">
      <div class="category-item" :class="{on: category_id == ''}" @click="select('',$t('c.CategorySelect.text1'))">
        <div class="wh32 mr16">
          <pic :src="`${this.GL.PIC_HOST}/static/img/category/all@2x.png`"></pic>
        </div>{{$t('c.CategorySelect.text1')}}
      </div>
      <div
        class="category-item mt16"
        v-if="category.name != '摄影'"
        :class="{on: category_id == category.category_id}"
        @click="select(category.category_id, category.name)"
        v-for="(category, i) in list"
        :key="category.category_id"
      >
        <div class="wh32 mr16">
          <pic :src="category.pic"></pic>
        </div>
        {{category.name}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "category-select",
  props: {
    list: {
      default() {
        return [];
      }
    }
  },
  components: {},
  data() {
    return {
      category_id: "",
      category_name: this.$t('c.CategorySelect.text1'),
      is_active: false
    };
  },
  computed: {
    ...mapState("app", ["browser_size"])
  },
  mounted() {},
  methods: {
    open_img(src) {
      this.$mixin_show_modal_img(0, [src]);
    },
    open() {
      if (this.browser_size == "small") {
        this.is_active = true;
      }
    },
    select(id, name) {
      let is_change = this.category_id != id;
      this.category_id = id;
      this.category_name = name;
      this.is_active = false;
      if (is_change) {
        this.$emit("change", { category_id: id, name: name });
      }
    },
    close() {
      this.is_active = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-category-select {
  position: relative;

  .category-item {
    width: 100%;
    padding: px2rem(8) px2rem(16);
    background: $white;
    border-radius: px2rem(4);
    color: $black-8;
    display: flex;
    align-items: center;
    border: 1px solid $black-1;
    box-sizing: border-box;

    &.on {
      border-color: $purple;
      color: $purple;
    }

    &:hover {
      cursor: pointer;
      background: $white-bg;
    }
  }

  @media (max-width: $width-mobile) {
    .category-list {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      display: none;

      &.active {
        border: 1px solid $purple;
        border-radius: px2rem(4);
        z-index: 1;
        display: block;
        max-height: px2rem(300);
        overflow-y: scroll;

        .category-item {
          padding: px2rem(12) px2rem(16);
          border: 0;
          margin-top: 0 !important;
          border-radius: 0;
        }
      }
    }

    .category-item {
    }
  }
}
</style>
